import { createContext, useContext } from "react";
import type { useAiAssistantAdmin } from "./use-ai-assistant-admin";

export type AiAssistantAdminValue = ReturnType<typeof useAiAssistantAdmin> & {
	/** Form dikunci selama overview dimuat atau endpoint admin tidak terjangkau. */
	disabled: boolean;
};

const AiAssistantAdminContext = createContext<AiAssistantAdminValue | null>(
	null,
);

export const AiAssistantAdminProvider = AiAssistantAdminContext.Provider;

/** Overview admin AI yang dimuat sekali oleh layout `/admin/ai-assistant`, dibagi ke semua sub menu. */
export function useAiAssistantAdminContext(): AiAssistantAdminValue {
	const value = useContext(AiAssistantAdminContext);
	if (!value) {
		throw new Error(
			"useAiAssistantAdminContext harus dipakai di dalam AiAssistantAdminLayout",
		);
	}
	return value;
}
